<template>
  <div>
    <HomeDetailInfoSiteOne>
      <template #header-one>
        <h1 style="max-width: 800px"> We need assistance systems for data to do real time decisions. AUTO.pilots help you with these problems of the future. By the four levels you are able to customize artificial intelligence to your needs.  </h1>
      </template>
      <template #text-one>
        <p :style="`max-width: 700px;
        font-style: normal;
        font-size: 20px;

        ${$vuetify.breakpoint.smAndDown ? 'padding: 50px 20px 20px 20px' : 'padding: 50px 20px 30px 20px;'}`">

        </p>
      </template>
      <template #image>
        <img style="border-radius: 10px" :width="$vuetify.breakpoint.smAndDown ? '300%' : '70%'" src="@/assets/AlgorithmicFlow-AutoPilots.png">
      </template>
    </HomeDetailInfoSiteOne>
  </div>
</template>

<script>
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'

export default {
  components: {
    HomeDetailInfoSiteOne
  }
}
</script>
